import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-dark-800 py-20 px-4" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl leading-relaxed text-gray-300" data-id="element-137">
          <p className="font-medium text-white" data-id="element-138">
            <span className="text-gold-500 font-bold" data-id="element-139">
              Sabés lo que es sentir que el momento se escapa demasiado rápido.
            </span>
          </p>

          <p data-id="element-140">
            Que todo esté bien, que haya química, que haya ganas… pero que el
            cuerpo no te acompañe como querés.
          </p>

          <p data-id="element-141">
            Y después la vuelta mental: "¿Por qué me pasó de vuelta?", "¿Va a
            volver a pasar?", "¿Se dio cuenta?".
          </p>

          <div className="p-6 bg-dark-700/50 border-l-4 border-gold-500 rounded-r-lg" data-id="element-142">
            <p className="text-white font-semibold" data-id="element-143">
              No sos el único.{' '}
              <span className="text-gray-400 font-normal" data-id="element-144">
                Es más común de lo que pensás. Y no tiene por qué definir tu
                vida sexual ni tu confianza.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}